function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M15.993 4.244a.486.486 0 0 0-.044-.202.428.428 0 0 0-.297-.243L8.18.046a.43.43 0 0 0-.385 0L.249 3.833A.458.458 0 0 0 0 4.228v9.525c0 .174.095.334.25.41l7.545 3.788c.003 0 .003 0 .007.003.01.004.022.008.033.016.004 0 .007.003.015.003l.033.012c.003 0 .007.004.01.004.012.003.026.003.037.007h.011c.015 0 .033.004.048.004s.033 0 .048-.004h.01a.126.126 0 0 0 .037-.007c.004 0 .008-.004.011-.004l.033-.012c.004 0 .008-.003.015-.003a.128.128 0 0 0 .033-.016c.004 0 .004 0 .007-.003l7.568-3.8a.461.461 0 0 0 .249-.41V4.255c-.007-.004-.007-.008-.007-.011zM7.985.96l6.544 3.286-2.41 1.212-6.544-3.286L7.985.961zm0 6.573L1.442 4.247l3.125-1.569 6.543 3.287-3.125 1.569zM.88 4.98l6.665 3.347v8.483L.88 13.464V4.98zm7.545 11.83V8.328l3.13-1.573v2.218c0 .251.197.456.44.456a.45.45 0 0 0 .44-.456V6.31l2.677-1.345v8.484L8.425 16.81z"
});

var SvgItemSvg = function SvgItemSvg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgItemSvg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/itemSvg.ea89b0cb.svg";
export { ForwardRef as ReactComponent };